import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "./context/userContext";

const PrivateRoute = ({ children }) => {
  const { userLoggedIn } = useUser();
  return userLoggedIn ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
